/* src/app/views/plans-details-edit/price-details-edit/price-details-edit.component.scss */
.container {
  width: 100%;
  max-width: 1680px;
  margin: 0 auto 24px;
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
  border-radius: 6px;
  overflow: hidden;
}
.container-header {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.title-position {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.title {
  font-weight: normal;
  font-style: normal;
  font-size: clamp(28px, 2.2vw, 48px);
  line-height: 1.2;
  color: #333333;
  margin: 10px 0 0 48px;
}
.sub-title {
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(14px, 1.1vw, 22px);
  line-height: 1.3;
  color: #5f5f5f;
  margin-top: 2px;
}
.container-body {
  margin-bottom: 0;
  width: 100%;
  border: none;
}
.product-itens {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 8px 36px 0;
  display: flex;
  flex-wrap: wrap;
}
.message-edit {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 24px);
  margin: 0 -12px;
  padding: 0;
}
.message-edit > [class*=col-] {
  padding: 0 12px 16px;
}
.element-edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-edit-input {
  margin-top: 5px;
  width: 100%;
  max-width: 100%;
}
.element-edit-label {
  margin-bottom: 5px;
}
.large-text {
  height: 39px !important;
}
.space-first,
.space-second {
  margin-left: 0;
}
.disabled-input:disabled {
  background-color: #e5e5e5;
  color: #202020;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.element-edit > .message-edit {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
}
.element-edit ::ng-deep .p-message {
  display: flex;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 0;
}
.button-position {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 22px 36px 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.action-button,
.undo-action-button {
  width: 180px;
  height: 48px;
  border-radius: 10px;
  margin: 0;
}
.action-button {
  background: #046cea;
  border: 1px solid #046cea;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:hover {
  background: #044ea7;
}
.undo-action-button {
  background: #ffffff;
  border: 1px solid #046cea;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.undo-action-button:hover {
  background: #044ea7;
}
button.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
@media only screen and (max-width: 1200px) {
  .title,
  .sub-title {
    margin-left: 28px;
  }
  .product-itens,
  .button-position {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media only screen and (max-width: 768px) {
  .container-header {
    margin-top: 12px;
  }
  .title,
  .sub-title {
    margin-left: 16px;
  }
  .title {
    margin-top: 4px;
    font-size: clamp(24px, 6vw, 32px);
  }
  .sub-title {
    margin-top: 6px;
  }
  .product-itens,
  .button-position {
    padding-left: 16px;
    padding-right: 16px;
  }
  .button-position {
    padding-top: 18px;
    padding-bottom: 24px;
  }
  .element-edit {
    font-size: 14px;
    line-height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .action-button,
  .undo-action-button {
    width: 100%;
  }
  .button-position {
    gap: 10px;
  }
  .large-text {
    height: 38px !important;
  }
}
@media only screen and (min-width: 1920px) {
  .product-itens,
  .button-position {
    max-width: 1520px;
  }
}
.product-itens {
  padding: 8px 36px 0;
  max-width: 1240px;
  margin: 0 auto;
}
.product-itens > .message-edit {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  width: 100%;
  margin: 0;
  padding: 0 !important;
}
.product-itens > .message-edit > .element-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
  padding: 0 12px 16px;
}
.product-itens > .message-edit > .element-edit:only-child {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.space-first,
.space-second {
  margin-left: 0 !important;
}
@media only screen and (max-width: 768px) {
  .product-itens {
    padding: 8px 16px 0;
  }
  .product-itens > .message-edit > .element-edit {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
/*# sourceMappingURL=price-details-edit.component-AFTTQ5IT.css.map */
